import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useClient from "../../api/hooks/useClients";
import { toIcons } from "../../consts/Paths";
import MainContext from "../../context/MainContext";
import { offerRemappingFromResult } from "../../utils/offerRemapping";

const OpenOfferTag = (props: any) => {
  const navigate = useNavigate();

  const { setOffer } = useContext(MainContext);

  const handleRedirectToOffer = () => {
    const remappedOffer = offerRemappingFromResult(props.offer);
    setOffer(remappedOffer); 
    navigate(`/offers/${props.offer.id}`);
  };

  return (
    <div className="open-offer-tag" onClick={handleRedirectToOffer}>
      <div
        className="open-offer-image"
        style={{
          backgroundImage: `url(${props.offer.imageSrc})`,
          border: "1px solid lightgrey",
        }}
      ></div>
      <div className="open-offer-info">
        <p className="open-offer-title">{props.offer.offer_name}</p>
        <p className="open-offer-agency">{props.offer.client.name}</p>
      </div>
      <img className="open-offer-icon" src={`${toIcons}/small-right.svg`} />
    </div>
  );
};
export default OpenOfferTag;
